export const Copied = "Copied to clipboard";
export const CopyLink = "Copy permalink";
export const ExpandGroup = "Expand group on line {0}";
export const LogSection = "Logs section";
export const SearchKeyword = "Type a keyword to search..";
export const SpinnerLabel = "Loading...";
